import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const WithdrawSummaryGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewWithdrawSummary === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

WithdrawSummaryGuard.propTypes = {
  children: PropTypes.node,
};

export default WithdrawSummaryGuard;
